// stores/useEditorConfigStore.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export type EditorMode = 'single' | 'multi' | 'design'

export const useEditorConfigStore = defineStore(
    'editorConfig',
    () => {
        /**
         * Kontext aus Einstieg (Kategorie / Produkt)
         */
        const categoryId = ref<number | null>(null)
        const categoryIri = ref<string | null>(null)
        const categoryTitle = ref<string | null>(null)

        const productId = ref<number | null>(null)
        const productIri = ref<string | null>(null)
        const productTitle = ref<string | null>(null)

        /**
         * Editor-Modus
         * - single: 1 Bild
         * - multi: mehrere Bilder
         */
        const mode = ref<EditorMode | null>(null)

        /**
         * Flags für UI / Navigation
         */
        const isReady = computed(() => !!(productId.value && mode.value))

        /* =========================
           Actions
        ========================= */

        function setCategory(payload: { id: number; iri?: string | null; title?: string }) {
            categoryId.value = payload.id
            categoryIri.value = payload.iri ?? `/api/categories/${payload.id}`
            categoryTitle.value = payload.title ?? null
        }

        function setProduct(payload: { id: number; iri?: string | null; title?: string }) {
            productId.value = payload.id
            productIri.value = payload.iri ?? `/api/products/${payload.id}`
            productTitle.value = payload.title ?? null
        }
        // ✅ ALIAS für alten Code


        function setMode(next: EditorMode) {
            mode.value = next
        }

        function reset() {
            categoryId.value = null
            categoryIri.value = null
            categoryTitle.value = null
            productId.value = null
            productIri.value = null
            productTitle.value = null
            mode.value = null
        }

        return {
            // state
            categoryId,
            categoryIri,
            categoryTitle,
            productId,
            productIri,
            productTitle,
            mode,

            // getters
            isReady,

            // actions
            setCategory,
            setProduct,
            setMode,
            reset,
        }
    },
    {
        persist: {
            storage: localStorage,
            pick: [
                'categoryId',
                'categoryIri',
                'categoryTitle',
                'productId',
                'productIri',
                'productTitle',
                'mode',
            ],
        },
    },
)
